import React from 'react';

import { Box, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export type SearchFormValues = {
  search: string;
};

interface SearchFieldProps {
  searchForm: UseFormReturnType<SearchFormValues>;
}

export function SearchField({ searchForm }: SearchFieldProps) {
  const { t } = useTranslation();

  return (
    <Box style={{ flexShrink: 0, padding: '0 16px' }}>
      <TextInput
        placeholder={t('APP.ACTIONS.SEARCH')}
        icon={<IconSearch size={14} />}
        sx={(theme) => ({
          input: {
            fontSize: '13px',
            backgroundColor: theme.colors.gray[0],
            border: `1px solid ${theme.colors.gray[1]}`,
            transition: 'all 0.15s ease',
            '&:focus': {
              border: `1px solid ${theme.colors.gray[3]}`
            }
          }
        })}
        {...searchForm.getInputProps('search')}
      />
    </Box>
  );
}
